import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'DOCUMENT_FORM'
export const DocumentFormAction = createFormAction(FORM_KEY)